import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { AssetActionControlRequest } from "./asset-action-control.dto";


export class AllAssetResponseModel extends GlobalResponseObject {
    data?: AssetActionControlRequest[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: AssetActionControlRequest[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}